import React from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import { Controller, useFormContext } from 'react-hook-form';
import scssVariables from 'styles/variables.module.scss';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { AdvancedWrapperTooltipContent } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/SearchByName/components/AdvancedWrapperTooltipContent/AdvancedWrapperTooltipContent';
import { Switch } from 'components/DesignSystem/Switch';
import { TextInput } from 'components/DesignSystem/TextInput';
import { CustomizedRoundIcon, CustomizedTooltip } from 'components/common';

export const SearchByName = ({ onFiltersChanged }) => {
    const { control, watch } = useFormContext<IFields>();
    const { mediaLaptop } = scssVariables;
    const isLaptop = useMediaQuery(`(max-width: ${mediaLaptop})`);

    return (
        <div className={`${classes.selectWrapper} ${classes.textSearchInputWrapper}`}>
            <Controller
                render={({ field }) => (
                    <TextInput
                        id={'battlecards-filters-card-search'}
                        {...field}
                        onChange={(e) => {
                            field.onChange(e.currentTarget.value);
                            onFiltersChanged({ [field.name]: e.target.value });
                        }}
                        placeholder={'Search by name or Id...'}
                        onClear={() => {
                            onFiltersChanged({ [field.name]: '' });
                        }}
                        maxLength={300}
                    />
                )}
                name={`cardSearch`}
                control={control}
            />

            <div className={classes.advancedWrapper}>
                <Switch
                    checked={watch('flags').isAdvancedTextSearch ? watch('flags').isAdvancedTextSearch : false}
                    onChange={() => {
                        onFiltersChanged({
                            flags: {
                                ...watch('flags'),
                                isAdvancedTextSearch: !watch('flags').isAdvancedTextSearch,
                            },
                        });
                    }}
                    label={'Advanced'}
                />

                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Bottom}
                    contentStyles={{
                        maxWidth: isLaptop ? '400px' : '650px',
                    }}
                    key={'advancedInfo'}
                    tooltipContent={<AdvancedWrapperTooltipContent />}
                    triggerElement={
                        <CustomizedRoundIcon enableHover={true} size={'24px'}>
                            <Icon name={'info-icon'} size={'14'} />
                        </CustomizedRoundIcon>
                    }
                />
            </div>
        </div>
    );
};
